import React from 'react';

import {Listbox} from '@pb/kit-component-listbox';

import {AutosuggestContext} from './autosuggest.context';

import type {AutosuggestContextType} from './autosuggest.context';
import type {ListboxProps} from '@pb/kit-component-listbox';


export interface AutosuggestListProps extends ListboxProps {
    contextValue: AutosuggestContextType,
}

/**
 * The `AutosuggestList` component is used to render the list of suggestions in the Autosuggest component.
 * Use it to render the list of suggestions.
 * Should be used with `useAutosuggest` hook.
 */
export function AutosuggestList({
    children,
    contextValue,
    ...listboxProps
}: AutosuggestListProps) {
    return (
        <AutosuggestContext.Provider value={contextValue}>
            <Listbox{...listboxProps}>
                {children}
            </Listbox>
        </AutosuggestContext.Provider>
    );
}
